export function normalizeArrayResponse(response, context = '') {
  let data = response && response.data;

  // If the endpoint returned a string (often an HTML error page), try to parse JSON
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      const snippet = data.substring ? data.substring(0, 1000) : String(data);
      const err = new Error(
        `Invalid API response: expected array, got string (unable to parse). Context: ${context}`
      );
      err.raw = snippet;
      err.type = 'invalid_response_string';
      throw err;
    }
  }

  // If it's already an array, return it
  if (Array.isArray(data)) return data;

  // Common wrapper shapes returned by some APIs
  const candidates = [
    data?.value,
    data?.documents,
    data?.items,
    data?.results,
    data?.rows,
  ];

  for (const c of candidates) {
    if (Array.isArray(c)) return c;
  }

  // If it's an object that looks like a single association, wrap it
  if (data && typeof data === 'object') {
    return [data];
  }

  // Fallback: throw with helpful details
  const type = data === null ? 'null' : typeof data;
  const preview = (() => {
    try {
      const s = JSON.stringify(data);
      return s.length > 1000 ? s.substring(0, 1000) + '...' : s;
    } catch (e) {
      return String(data);
    }
  })();

  const err = new Error(`Invalid API response: expected array, got ${type}` + (context ? ` (context: ${context})` : ''));
  err.preview = preview;
  err.type = 'invalid_response_shape';
  throw err;
}

export default normalizeArrayResponse;
